import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useCustomerAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useCustomerAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/account");
      return;
    }
    api.post("/auth/google/session", { session_id: sessionId })
      .then((r) => {
        setUser(r.data);
        navigate("/account", { state: { user: r.data }, replace: true });
      })
      .catch(() => navigate("/account", { replace: true }));
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex min-h-[70vh] items-center justify-center" data-testid="auth-callback">
      <Loader2 className="animate-spin text-emerald-300" size={32} />
    </div>
  );
}
